import { AdmService } from '../../../shared/services/adm.service';
import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { Compania } from 'src/app/shared/models/compania';
import { ConfigService } from 'src/app/shared/services/config.service';
import { Cuenta } from 'src/app/shared/models/cuenta';
import { DataClientePedidos } from 'src/app/shared/models/dataClientePedidos';
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, map, startWith, switchMap, tap } from 'rxjs';
import { Division } from 'src/app/shared/models/division';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { GrupoCliente } from 'src/app/shared/models/grupoCliente';
import { IdentityRole } from 'src/app/shared/models/identityRole';
import { ClasePorEstado, isMobile, isMobileXL, loadData, scrollToInvalidFromControls } from 'src/app/shared/utils/helpers';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { Pais } from 'src/app/shared/models/pais';
import { ParametrosService } from 'src/app/shared/services/parametros.service';
import { PEPService } from 'src/app/shared/services/pep.service';
import { Region } from 'src/app/shared/models/region';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SelectorDivisionesComponent } from 'src/app/shared/components/selector-divisiones/selector-divisiones.component';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { Usuario } from 'src/app/shared/models/usuario';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
import { ZonaVendedor } from 'src/app/shared/models/zonaVendedor';
import { Direccion } from 'src/app/shared/models/direccion';
import { Distribuidor } from 'src/app/shared/models/distribuidor';
import { CuentaDistribuidor } from 'src/app/shared/models/cuentaDistribuidor';
import { Deposito } from 'src/app/shared/models/deposito';
import { Moneda } from 'src/app/shared/models/moneda';
import { DatePipe } from '@angular/common';
import { TerminoPago } from 'src/app/shared/models/terminoPago';
import { ListaPrecioCabecera } from 'src/app/shared/models/listaPrecioCabecera';
import { PedidoEspecialPlantaCabecera } from 'src/app/shared/models/pedidoEspecialPlantaCabecera';
import { PedidoEspecialPlantaItem } from 'src/app/shared/models/pedidoEspecialPlantaItem';
import { ListaPrecioItem } from 'src/app/shared/models/listaPrecioItem';
import { UbicacionAlmacenamiento } from 'src/app/shared/models/ubicacionAlmacenamiento';
import { DataSource } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { PedidoEspecialPlantaItemDescuento } from 'src/app/shared/models/pedidoEspecialPlantaItemDescuento';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
;
import { ProductosService } from 'src/app/shared/services/productos.service';
import { ComentarioPedidoDialogComponent } from 'src/app/shared/components/comentario-pedido-dialog/comentario-pedido-dialog.component';
import { CuotaPlanta } from 'src/app/shared/models/cuotaPlanta';

import { PedidoEspecialPlantaFactura } from 'src/app/shared/models/pedidoEspecialPlantaFactura';
import { PedidoEspecialPlantaRemito } from 'src/app/shared/models/pedidoEspecialPlantaRemito';
import { PEPAItemDialogComponent } from './pepa-item-dialog.component';
import { PEPALogsDialogComponent } from './pepa-logs-dialog.component';
import { PEPARetencionesDialogComponent } from './pepa-retenciones-dialog.component';
import { PEPAprobacionRetenidoDialogComponent } from '../../pedidos-especiales-planta/components/pep-aprobacion-retenido-dialog.component';
import { PedidoEspecialPlantaRetencion } from 'src/app/shared/models/pedidoEspecialPlantaRetencion';

@Component({
  selector: 'app-pepa',
  templateUrl: './pepa.component.html'
})
export class PEPAComponent {


  descuentosDiscrecionalesNegativos: boolean = false;
  itemsConDescuentoDiscrecionalNegativo: PedidoEspecialPlantaItem[] = [];
  @ViewChild('top') top: ElementRef;
  idTipo: number = 0;
  totalItems: number = 0;
  @ViewChild('selectDivisiones') selectDivisiones: MatSelect;
  @ViewChild('idGrupoCliente') idGrupoCliente: MatSelect;
  @ViewChild('pepa') pepa: ElementRef;
  codigoEdit: number = 0;
  rolesConRegion: ItemParametro[] = [];
  selectRegiones: boolean = true;
  ctaDistribuidorSeleccionada: CuentaDistribuidor;
  cuentasDistribuidores: CuentaDistribuidor[] = []; //Dorados
  gcSeleccionado: GrupoCliente;
  gcs: GrupoCliente[] = [];
  companias: Compania[] = [];
  salesOrgs: SalesOrg[] = [];
  divisiones: Division[] = [];
  regiones: Region[] = [];
  plantas: Deposito[] = [];
  plantasItem: Deposito[] = [];
  motivosRetencion: ItemParametro[] = []
  pepaForm: FormGroup;
  pepaItemForm: FormGroup;
  monedas: Moneda[] = [];

  terminosPago: TerminoPago[] = [];
  tpSeleccionado: TerminoPago;
  avisoCreditoVencido: boolean = false;
  regionSeleccionada: Region;
  monedaSeleccionada: Moneda;
  plantaSeleccionada: Deposito;
  plantaItemSeleccionada: Deposito;
  storageLocationSeleccionado: UbicacionAlmacenamiento;
  storagesLocations: UbicacionAlmacenamiento[] = [];
  slSeleccionado: UbicacionAlmacenamiento;
  divisionSeleccionada: Division;
  ctaDistrubuidorSeleccionada: CuentaDistribuidor;
  salesOrgSeleccionada: SalesOrg;
  companiaSeleccionada: Compania;
  guardoDireccion: boolean = false;
  alta: boolean = false;
  mensajeDeudaVencida: string = "";
  mensajeCreditoExcedido: string = "";
  credito: number = null;
  cuotaPlantaSeleccionada: CuotaPlanta = new CuotaPlanta();
  cuotasPlantas: CuotaPlanta[] = [];

  avisoUnidadesPallet: boolean = false;
  mensajeUnidadesPallet: string;
  minDate: Date;
  dirEntregas: Direccion[] = [];
  dirEntregaSeleccionada: Direccion;

  retenciones: PedidoEspecialPlantaRetencion[] = []

  //#region grillas

  displayedColumnsItems = ['acciones', 'nroLinea', 'idProducto', 'producto', 'cantidad', 'planta', 'cuotaPlantaMesyAnio', 'precioUnitarioLista', 'totalDescuento', 'idMoneda', 'precioUnitarioFinal', 'recargo', 'totalPrecioKGL', 'total']; //  'stock', 'estado',
  displayedColumnsItemsDescuentos = ['nroLinea', 'idProducto', 'producto', 'idTipoCondicion', 'tipoCondicion', 'importe', 'porcentaje', 'descuento'];
  displayedColumnsFacturas = ['acciones', 'nroLinea', 'nroFactura', 'nroRemito', 'fechaVencimiento', 'idProducto', 'idLote', 'cantidad', 'totalFactura', 'nombrePDF'];
  displayedColumnsRemitos = ['acciones', 'nroRemito', 'idProducto', 'idLote', 'cantidad', 'fecha', 'nombrePDF'];
  dataSourceItems = new MatTableDataSource<PedidoEspecialPlantaItem>();
  dataSourceItemsDescuentos = new MatTableDataSource<PedidoEspecialPlantaItemDescuento>();
  dataSourceFacturas = new MatTableDataSource<PedidoEspecialPlantaFactura>();
  dataSourceRemitos = new MatTableDataSource<PedidoEspecialPlantaRemito>();

  @ViewChild('matSortItems') matSortItems: MatSort;
  @ViewChild('matSortItemsDescuentos') matSortItemsDescuentos: MatSort;
  @ViewChild('matSortFacturas') matSortFacturas: MatSort;
  @ViewChild('matSortRemitos') matSortRemitos: MatSort;
  @ViewChild('matPaginatorItems') matPaginatorItems: MatPaginator;
  @ViewChild('matPaginatorItemsDescuentos') matPaginatorItemsDescuentos: MatPaginator;
  @ViewChild('matPaginatorFacturas') matPaginatorFacturas: MatPaginator;
  @ViewChild('matPaginatorRemitos') matPaginatorRemitos: MatPaginator;

  //#endregion

  //#region autocomplete Cliente

  clientesEncontrados: any;
  clienteSeleccionado: Cuenta;
  fcAutocompleteCliente = new FormControl('');
  hintC: string = ""
  loadingFcAutocompleteCliente = false;
  minLengthTermCliente = 2;

  //#endregion

  //#region autocomplete ZonaVendedor

  zvsEncontradas: any;
  zvSeleccionada: ZonaVendedor;
  fcAutocompleteZv = new FormControl('');
  hintZV: string = ""
  loadingFcAutocompleteZV = false;
  minLengthTermZV = 2;

  //#endregion

  //#region autocomplete Lista precios

  lpsEncontradas: any;
  lpSeleccionada: ListaPrecioCabecera;
  fcAutocompleteLP = new FormControl('');
  hintLP: string = ""
  loadingFcAutocompleteLP = false;
  minLengthTermLP = 1;

  //#endregion
  //#region autocomplete Ítem

  itemsEncontrados: any;
  itemSeleccionado: ListaPrecioItem;
  fcAutocompleteItem = new FormControl('');
  hintItem: string = ""
  loadingFcAutocompleteItem = false;
  minLengthTermItem = 1;
  paramCodigo: string = "";
  //#endregion
  constructor(
    private admService: AdmService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private parametrosService: ParametrosService,
    private pepService: PEPService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    private usuarioService: UsuariosService,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private productosService: ProductosService,

  ) {

    this.pepaForm = this.fb.group({
      idSalesOffice: [''],
      codigosRetencionesAprobadas: [[]],
      aprobar: [false],
      aprobarParcial: [false],
      aprobarReservado: [false],
      borrador: [false],
      rechazar: [false],
      reenviar: [false],
      transferir: [false],
      autor: [''],
      calleNroDireccionEntrega: [''],
      ciudadDireccionEntrega: [''],
      cpDireccionEntrega: [''],
      cuit: [''],
      descuentoDiscrecional: [0],
      comentario: [''],
      idMoneda: ['', Validators.required],
      fechaCreacion: [new Date()],
      idCompania: [''],
      compania: [''],
      idDivision: ['', Validators.required],
      division: [''],
      idEstado: [1],
      estado: ['Borrador'],
      mensajeIntegracion: [''],
      glosa: [''],
      idGrupoCliente: ['', Validators.required],
      grupoCliente: [''],
      idRegion: ['', Validators.required],
      idSalesOrg: [''],
      salesOrg: [''],
      idTaxClassification: [''],
      idZonaVendedor: ['', Validators.required],
      nombreCliente: [''],
      nombreClienteDireccionEntrega: [''],
      nombreDistribuidor: [''],
      motivoRetencion: [''],
      nroCliente: [''],
      nroClienteDireccionEntrega: [''],
      nroClienteDistribuidor: [''], //nroCLiente del distribuidor seleccionado
      nroOrdenSAP: [0],
      nroPedido: [0],
      usuarioRedZonaVendedor: [''],
      idFormaPago: ['1'],
      tipoOrden: ['Pedido Especial Planta Anticipada'],
      idTipoEntrega: [''],
      tipoEntrega: [''],
      idTipoListaPrecios: ['', Validators.required],
      tipoListaPrecios: [''],
      idTerminoPago: ['', Validators.required],
      terminoPago: [''],
      nroRemito: [''],
      items: [[]],
      itemsDescuento: [[]],
      habilitacion: [true],
      idPais: [''],
      moneda: [''],
      region: [''],
      idMonedaCD: [''],
      idCerealContrato: [''],
      cerealContrato: [''],
      idTipoContrato: [''],
      tipoContrato: [''],
      idCorredorContrato: [''],
      corredorContrato: [''],
      usuarioRedSolicitante: [''],
      solicitante: [''],
      preciosFijos: [false],
      comentarioLogAutorizacion: [''],
      idMotivoRetencion: [''],
      nombreVendedor: [''],
      idTipoOrden: ['10'],
      fechaPrecio: [''],
      idPlanta: ['', Validators.required],
      planta: [''],
      codigo: [0]
    })

    this.pepaItemForm = this.fb.group({

      idEstado: ['-1'],
      estado: [''],
      autor: [''],
      cantidad: [1, [Validators.min(0.001), Validators.max(0)]],
      cultivo: [''],
      descuentoCategoria: [0],
      descuentoDiscrecional: [0],
      habilitacion: [true],
      idCompania: [''],
      idCultivo: [''],
      idDivision: [''],
      idLote: [''],
      idPais: [''],
      idProducto: ['', Validators.required],
      idSalesOrg: [''],
      idTipoOrden: ['10'],
      idTipoEntrega: [''],
      tipoEntrega: [''],
      nroLinea: [0],
      nroPedido: [0],
      porcentajeRecargo: [0],
      precioFinal: [0],
      precioKGL: [0],
      precioUnitarioFinal: [0],
      precioUnitarioLista: [0],
      producto: ['', Validators.required],
      recargo: [0],
      recargoLocal: [0],
      tipoOrden: ['Pedido Especial Planta Anticipada'],
      total: [0],
      totalDescuento: [0],
      totalLocal: [0],
      totalPrecioKGL: [0],
      fechaCreacion: [new Date()],
      idUbicacionAlmacenamiento: ['', Validators.required],
      idPlanta: ['', Validators.required],
      planta: [''],
      cuotaPlantaMesyAnio: ['', Validators.required],
      codigo: [0]
    })

  }

  public Tooltips: {
    Eliminar: string
    Editar: string
    Ver: string;
  }
  public Mensajes: {
    CreditoVencido: string,
    DescuentosNegativos: string,
  }
  public Validaciones: {
    Cantidad: string
    Cliente: string
    DireccionEntrega: string
    ListaPrecios: string
    ZonaVendedor: string
    NroClienteDistribuidor: string
    IdRegion: string
    IdMoneda: string
    IdDivision: string
    IdGrupoCliente: string
    IdTerminoPago: string
    IdPlanta: string
    StorageLocation: string
    CuotaPlanta: string
  }
  public Etiquetas: {
    Acciones: string
    Buscar: string
    CalleNroDireccionEntrega: string
    Cantidad: string
    CiudadDireccionEntrega: string
    Cliente: string
    Comentario: string
    Compania: string
    CPDireccionEntrega: string
    CuentaDistribuidor: string
    CuitCliente: string
    DescripcionItemDescuento: string
    Descuento: string
    DescuentoCategoria: string
    DescuentoDiscrecional: string
    DireccionEntrega: string
    Division: string
    Estado: string
    Fecha: string
    FechaCreacion: string
    FechaDesde: string
    FechaEstado: string
    FechaHasta: string
    FechaPrecio: string
    FechaVencimiento: string
    Glosa: string
    IdGrupoCliente: string
    IdLote: string
    IdMoneda: string
    IdProducto: string
    IdTaxClassification: string
    IdTipoCondicion: string
    IdTipoListaPrecios: string
    Importe: string
    Item: string
    MensajeIntegracion: string
    MotivoRetencion: string
    NombreCliente: string
    NombreClienteDireccionEntrega: string
    NombreDistribuidor: string
    NombrePDF: string
    NroCliente: string
    NroClienteDireccionEntrega: string
    NroFactura: string,
    NroLinea: string,
    NroOrdenSAP: string
    NroPedido: string
    NroRemito: string
    Path: string
    Planta: string
    Porcentaje: string
    PrecioKGL: string
    PrecioUnitarioFinal: string
    PrecioUnitarioLista: string
    Producto: string
    Recargo: string
    Region: string
    SalesOrg: string
    SinRegistros: string
    Stock: string
    StorageLocation: string
    TerminoPago: string
    TipoEntrega: string
    TipoListaPrecios: string
    TipoOrden: string
    Titulo: string
    Total: string
    TotalDescuento: string
    TotalFactura: string
    TotalLocal: string
    TotalPrecioKGL: string
    ZonaVendedor: string
    ZonaVendedorSeleccionada: string
    CuotaPlanta: string
    SalesOffice: string

  }
  ngAfterViewInit() {
    this.dataSourceItems.paginator = this.matPaginatorItems;
    this.dataSourceItems.sort = this.matSortItems;
    this.dataSourceItems.sort.disableClear = true;

    this.dataSourceItemsDescuentos.paginator = this.matPaginatorItemsDescuentos;
    this.dataSourceItemsDescuentos.sort = this.matSortItemsDescuentos;
    this.dataSourceItemsDescuentos.sort.disableClear = true;

    this.dataSourceFacturas.paginator = this.matPaginatorFacturas;
    this.dataSourceFacturas.sort = this.matSortFacturas;
    this.dataSourceFacturas.sort.disableClear = true;

    this.dataSourceRemitos.paginator = this.matPaginatorRemitos;
    this.dataSourceRemitos.sort = this.matSortRemitos;
    this.dataSourceRemitos.sort.disableClear = true;

  }
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.paramCodigo = params.codigo;
      if (typeof this.paramCodigo != 'undefined') {
        if (this.paramCodigo.length) {
          if (!isNaN(+this.paramCodigo)) {

            this.codigoEdit = parseInt(this.paramCodigo);
          }
        }
      }

      if (typeof params.idTipo != 'undefined') {
        if (params.idTipo.length) {
          if (!isNaN(+params.idTipo)) {

            this.idTipo = parseInt(params.idTipo);
          }
        }
      }
    });
    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Eliminar: this.configService.tooltips.Eliminar,

      Ver: this.configService.tooltips.Ver
    }

    this.Validaciones = {
      Cantidad: this.configService.validaciones.Cantidad,
      Cliente: this.configService.validaciones.Cliente,
      DireccionEntrega: this.configService.validaciones.DireccionEntrega,
      IdRegion: this.configService.validaciones.IdRegion,
      IdTerminoPago: this.configService.validaciones.IdTerminoPago,
      ListaPrecios: this.configService.validaciones.ListaPrecios,
      NroClienteDistribuidor: this.configService.validaciones.NroClienteDistribuidor,
      ZonaVendedor: this.configService.validaciones.ZonaVendedor,
      IdMoneda: this.configService.validaciones.IdMoneda,
      IdDivision: this.configService.validaciones.IdDivision,
      IdGrupoCliente: this.configService.validaciones.IdGrupoCliente,
      IdPlanta: this.configService.validaciones.IdPlanta,
      StorageLocation: this.configService.validaciones.StorageLocation,
      CuotaPlanta: this.configService.validaciones.CuotaPlanta
    }
    this.Mensajes = {
      CreditoVencido: this.configService.mensajes.CreditoVencido,
      DescuentosNegativos: this.configService.mensajes.DescuentosNegativos,
    }
    this.Etiquetas = {

      Acciones: this.configService.etiquetas.Acciones,
      Buscar: this.configService.etiquetas.Buscar,
      CalleNroDireccionEntrega: this.configService.etiquetas.CalleNroDireccionEntrega,
      Cantidad: this.configService.etiquetas.Cantidad,
      CiudadDireccionEntrega: this.configService.etiquetas.CiudadDireccionEntrega,
      Cliente: this.configService.etiquetas.Cliente,
      Comentario: this.configService.etiquetas.Comentario,
      Compania: this.configService.etiquetas.Compania,
      CPDireccionEntrega: this.configService.etiquetas.CPDireccionEntrega,
      CuentaDistribuidor: this.configService.etiquetas.CuentaDistribuidor,
      CuitCliente: this.configService.etiquetas.CuitCliente,
      DescripcionItemDescuento: this.configService.etiquetas.DescripcionItemDescuento,
      Descuento: this.configService.etiquetas.Descuento,
      DescuentoCategoria: this.configService.etiquetas.DescuentoCategoria,
      DescuentoDiscrecional: this.configService.etiquetas.DescuentoDiscrecional,
      DireccionEntrega: this.configService.etiquetas.DireccionEntrega,
      Division: this.configService.etiquetas.FilterDivision,
      Estado: this.configService.etiquetas.Estado,
      FechaCreacion: this.configService.etiquetas.FechaCreacion,
      FechaDesde: this.configService.etiquetas.FechaDesde,
      FechaEstado: this.configService.etiquetas.FechaEstado,
      FechaHasta: this.configService.etiquetas.FechaHasta,
      FechaPrecio: this.configService.etiquetas.PedidosEspecialesPlantaAnticipada.PEPA.FechaPrecio,
      Glosa: this.configService.etiquetas.Glosa,
      IdGrupoCliente: this.configService.etiquetas.IdGrupoCliente,
      IdMoneda: this.configService.etiquetas.IdMoneda,
      IdProducto: this.configService.etiquetas.IdProducto,
      IdTaxClassification: this.configService.etiquetas.IdTaxClassification,
      IdTipoCondicion: this.configService.etiquetas.IdTipoCondicion,
      IdTipoListaPrecios: this.configService.etiquetas.IdTipoListaPrecios,
      Importe: this.configService.etiquetas.Importe,
      Item: this.configService.etiquetas.Item,
      MensajeIntegracion: this.configService.etiquetas.MensajeIntegracion,
      MotivoRetencion: this.configService.etiquetas.MotivoRetencion,
      NombreCliente: this.configService.etiquetas.NombreCliente,
      NombreClienteDireccionEntrega: this.configService.etiquetas.NombreClienteDireccionEntrega,
      NombreDistribuidor: this.configService.etiquetas.NombreDistribuidor,
      NombrePDF: this.configService.etiquetas.NombrePDF,
      NroCliente: this.configService.etiquetas.NroCliente,
      NroClienteDireccionEntrega: this.configService.etiquetas.NroClienteDireccionEntrega,
      NroLinea: this.configService.etiquetas.NroLinea,
      NroOrdenSAP: this.configService.etiquetas.NroOrdenSAP,
      NroPedido: this.configService.etiquetas.NroPedido,
      NroRemito: this.configService.etiquetas.NroRemito,
      Path: this.configService.etiquetas.PedidosEspecialesPlantaAnticipada.PEPA.Path,
      Planta: this.configService.etiquetas.PedidosEspecialesPlantaAnticipada.PEPA.Planta,
      Porcentaje: this.configService.etiquetas.Porcentaje,
      PrecioKGL: this.configService.etiquetas.PrecioKGL,
      PrecioUnitarioFinal: this.configService.etiquetas.PrecioUnitarioFinal,
      PrecioUnitarioLista: this.configService.etiquetas.PrecioUnitarioLista,
      Producto: this.configService.etiquetas.Producto,
      Recargo: this.configService.etiquetas.Recargo,
      Region: this.configService.etiquetas.Region,
      SalesOrg: this.configService.etiquetas.SalesOrg,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      Stock: this.configService.etiquetas.Stock,
      StorageLocation: this.configService.etiquetas.StorageLocation,
      TerminoPago: this.configService.etiquetas.TerminoPago,
      TipoEntrega: this.configService.etiquetas.TipoEntrega,
      TipoListaPrecios: this.configService.etiquetas.TipoListaPrecios,
      TipoOrden: this.configService.etiquetas.TipoOrden,
      Titulo: this.configService.etiquetas.PedidosEspecialesPlantaAnticipada.PEPA.Titulo,
      Total: this.configService.etiquetas.Total,
      TotalDescuento: this.configService.etiquetas.TotalDescuento,
      TotalLocal: this.configService.etiquetas.TotalLocal,
      TotalPrecioKGL: this.configService.etiquetas.TotalPrecioKGL,
      ZonaVendedor: this.configService.etiquetas.ZonaVendedor,
      ZonaVendedorSeleccionada: this.configService.etiquetas.ZonaVendedorSeleccionada,
      IdLote: this.configService.etiquetas.Inventarios.IdLote,
      TotalFactura: this.configService.etiquetas.TotalFactura,
      FechaVencimiento: this.configService.etiquetas.FechaVencimiento,
      NroFactura: this.configService.etiquetas.NroFactura,
      Fecha: this.configService.etiquetas.Fecha,
      CuotaPlanta: this.configService.etiquetas.CuotaPlanta,
      SalesOffice: this.configService.etiquetas.IdSalesOffice
    }

    const hoy = new Date();
    const fifteenDaysAgo = new Date();
    fifteenDaysAgo.setDate(hoy.getDate() - 14);
    this.minDate = fifteenDaysAgo;

    this.fcAutocompleteCliente.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermCliente
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.clientesEncontrados = [];
          this.loadingFcAutocompleteCliente = true;
        }),
        switchMap(value => this.admService.cClientesPedidoAutocompleteSearch(this.loggedService.logged.idPais, this.pepaForm.controls['idCompania'].value, this.pepaForm.controls['idSalesOrg'].value, this.loggedService.logged.idDivision, this.loggedService.logged.idZonaVendedor, this.loggedService.logged.idRegion, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteCliente = false
            }),
          )
        )
      )
      .subscribe((data: Cuenta[]) => {
        this.clientesEncontrados = data;

      });

    this.fcAutocompleteZv.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermZV
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.zvsEncontradas = [];
          this.loadingFcAutocompleteZV = true;
        }),
        switchMap(value => this.admService.cZonasVendedoresAutocompleteSearch(this.loggedService.logged.idPais, this.pepaForm.controls['idCompania'].value, this.pepaForm.controls['idSalesOrg'].value, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteZV = false
            }),
          )
        )
      )
      .subscribe((data: ZonaVendedor[]) => {
        this.zvsEncontradas = data;

      });

    this.fcAutocompleteLP.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermLP
        }),
        distinctUntilChanged(),
        debounceTime(750),
        tap(() => {

          this.lpsEncontradas = [];
          this.loadingFcAutocompleteLP = true;
        }),

        switchMap(value => this.pepService.cListasPreciosAutocompleteSearch(this.loggedService.logged.idPais, this.pepaForm.controls['idCompania'].value,
          this.pepaForm.controls['idSalesOrg'].value, this.pepaForm.controls['nroCliente'].value, this.pepaForm.controls['idFormaPago'].value,
          this.pepaForm.controls['idGrupoCliente'].value, this.pepaForm.controls['idTipoOrden'].value, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteLP = false
            }),
          )
        )
      )
      .subscribe((data: ListaPrecioCabecera[]) => {
        if (data != null) {
          this.lpsEncontradas = data;

        }

      });

    this.fcAutocompleteItem.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermItem
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.itemsEncontrados = [];
          this.loadingFcAutocompleteItem = true;
        }),
        switchMap(value => this.pepService.cListaPrecioItemsAutocompleteSearch(this.loggedService.logged.idPais, this.pepaForm.controls['idCompania'].value,
          this.pepaForm.controls['idSalesOrg'].value, this.pepaForm.controls['idTipoListaPrecios'].value, this.pepaForm.controls['idTerminoPago'].value,
          this.pepaForm.controls['idMoneda'].value, this.pepaForm.controls['idPlanta'].value, '-1', value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteItem = false
            }),
          )
        )
      )
      .subscribe((data: ListaPrecioItem[]) => {
        this.scrollToInvalidFormControls(this.pepaForm);
        if (data != null) {
          this.itemsEncontrados = data;

        }

      });



    forkJoin([
      this.admService.cCompanias(this.loggedService.logged.idPais),
      this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
      this.admService.cDivisiones(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg, this.loggedService.logged.userName),
      this.parametrosService.cItemsParametros(10),
      this.parametrosService.cItemParametroXDescripcionItem(25, "PEPA"), //Cambiar descripcionItem segun tipo de pedido
      this.tablasService.cPlantas(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg),
      this.tablasService.cMonedas(this.loggedService.logged.idPais),
      this.pepService.cPedidoEspecialPlanta(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg, "10", this.codigoEdit),
      this.parametrosService.cItemsParametros(21), //Permisos Alta
    ]).subscribe((data: [Compania[], SalesOrg[], Division[], ItemParametro[], ItemParametro, Deposito[], Moneda[], PedidoEspecialPlantaCabecera, ItemParametro[]]) => {

      if (this.idTipo == 1) {
        if (data[8] != null) {
          if (data[8].length) {
            if (this.loggedService.validToken()) {
              data[8].forEach(rol => {
                if (this.loggedService.logged.rol == rol.idItem && !this.alta) {
                  this.alta = true;
                }
              });
            }
          }
        }
      }
      if (!this.alta && this.idTipo == 1) {
        this.volver();
      }

      if (data[0].length) {

        this.companias = data[0];
        if (this.codigoEdit == 0) {
          this.companiaSeleccionada = data[0][0];
        }

      }

      if (data[1].length) {

        this.salesOrgs = data[1];

      }

      if (data[2].length) {

        this.divisiones = data[2];
        if (this.codigoEdit == 0) {
          this.salesOrgSeleccionada = data[1][0];
        }

      }

      if (data[3].length) {

        this.motivosRetencion = data[3];

      }
      if (data[5].length) {
        this.plantas = data[5];
        this.plantasItem = data[5];
      }
      if (data[6].length) {

        this.monedas = data[6];

      }


      if (data[7] != null) {
        if (this.idTipo == 2 || this.idTipo == 3) {
          if (data[7].usuarioRedSolicitante == this.loggedService.logged.userName || this.isInRole('ADMVENTAS') || this.isInRole('ADM LOCAL') || this.isInRole('ADM')) {
            this.alta = true
          }
        }

        loadData(this.pepaForm, data[7])
        if (this.codigoEdit == 0) {

          this.pepaForm.controls['idCompania'].setValue(this.companias[0].id);
          this.pepaForm.controls['compania'].setValue(this.companias[0].descripcion);
          this.pepaForm.controls['idSalesOrg'].setValue(this.salesOrgs[0].id);
          this.pepaForm.controls['salesOrg'].setValue(this.salesOrgs[0].descripcion);
          this.pepaForm.controls['idDivision'].setValue(this.divisiones[0].id);
          this.pepaForm.controls['fechaPrecio'].setValue(new Date());
          this.seleccionarDivision(this.pepaForm.controls['idDivision'].value)
          this.pepaForm.controls['idMoneda'].setValue(this.monedas[0].id);
          this.seleccionarMoneda(this.pepaForm.controls['idMoneda'].value);
          this.pepaForm.controls['idPais'].setValue(this.loggedService.logged.idPais);
          this.codigoEdit = data[7].codigo;


        } else {
          var cabecera = data[7];
          if (cabecera.idEstado == 1) {
            this.admService
              .cMensajesCliente(cabecera.idPais, cabecera.idCompania, cabecera.idSalesOrg, cabecera.nroCliente)
              .subscribe((datac: DataClientePedidos) => {

                if (datac != null) {

                  this.mensajeDeudaVencida = datac.mensajeDeudaVencida;
                  this.mensajeCreditoExcedido = datac.mensajeCreditoExcedido;
                  this.credito = datac.credito;
                }

              })
          }
          this.pepaForm.controls['idDivision'].setValue(cabecera.idDivision);
          this.pepaForm.controls['division'].setValue(cabecera.division);
          this.companiaSeleccionada = new Compania();
          this.companiaSeleccionada.id = cabecera.idCompania;
          this.companiaSeleccionada.descripcion = cabecera.compania;

          this.salesOrgSeleccionada = new SalesOrg();
          this.salesOrgSeleccionada.id = cabecera.idSalesOrg;
          this.salesOrgSeleccionada.descripcion = cabecera.salesOrg;

          this.divisionSeleccionada = new Division();
          this.divisionSeleccionada.displayValue = cabecera.division + ' - ' + cabecera.idDivision;

          this.pepaForm.controls['cuit'].setValue(cabecera.cuit);
          this.pepaForm.controls['nroCliente'].setValue(cabecera.nroCliente);
          this.pepaForm.controls['nombreCliente'].setValue(cabecera.nombreCliente);
          this.zvSeleccionada = new ZonaVendedor();
          this.zvSeleccionada.displayValue = cabecera.idZonaVendedor + ' - ' + cabecera.nombreVendedor;

          this.dirEntregaSeleccionada = new Direccion();
          this.dirEntregaSeleccionada.nroCliente = cabecera.nroClienteDireccionEntrega

          this.ctaDistrubuidorSeleccionada = new CuentaDistribuidor();
          this.ctaDistrubuidorSeleccionada.nombre = cabecera.nombreDistribuidor;

          this.regionSeleccionada = new Region();
          this.regionSeleccionada.displayValue = cabecera.idRegion + ' - ' + cabecera.region;
          this.pepaForm.controls['region'].setValue(cabecera.region);

          this.gcSeleccionado = new GrupoCliente();
          this.gcSeleccionado.id = cabecera.idGrupoCliente;
          this.gcSeleccionado.descripcion = cabecera.grupoCliente;
          this.gcSeleccionado.displayValue = cabecera.idGrupoCliente + ' - ' + cabecera.grupoCliente;

          this.pepaForm.controls['idTipoListaPrecios'].setValue(cabecera.idTipoListaPrecios);
          this.pepaForm.controls['tipoListaPrecios'].setValue(cabecera.tipoListaPrecios);
          this.pepaForm.controls['idMonedaCD'].setValue(cabecera.idMonedaCD);
          this.pepaForm.controls['preciosFijos'].setValue(cabecera.preciosFijos);
          this.pepaForm.controls['idTerminoPago'].setValue(cabecera.idTerminoPago);
          this.pepaForm.controls['terminoPago'].setValue(cabecera.terminoPago);
          this.tpSeleccionado = new TerminoPago();
          this.tpSeleccionado.displayValue = cabecera.idTerminoPago + ' - ' + cabecera.terminoPago;

          this.pepaForm.controls['idMoneda'].setValue(cabecera.idMoneda);

          this.pepaForm.controls['moneda'].setValue(cabecera.moneda);
          this.monedaSeleccionada = new Moneda();
          this.monedaSeleccionada.id = cabecera.idMoneda;
          this.monedaSeleccionada.descripcion = cabecera.moneda;


          this.pepaForm.controls['idPlanta'].setValue(data[7].idPlanta);
          this.plantaSeleccionada = new Deposito();
          this.plantaSeleccionada.displayValue = cabecera.idPlanta + ' - ' + cabecera.planta;
          this.seleccionarPlantaItem(data[7].idPlanta); //  en el item pone la planta de la cabecera y carga storagelocations correspondientes

          this.dataSourceItems.data = (data[7].items != null) && data[7].items.length ? data[7].items : [];
          this.dataSourceItemsDescuentos.data = (data[7].itemsDescuento != null) && data[7].itemsDescuento.length ? data[7].itemsDescuento : [];
          if (this.dataSourceItems.data.length) {
            this.totalItems = this.dataSourceItems.data.map(a => a.total).reduce(function (a, b) {
              return a + b;
            });
            this.cDescuentosDiscrecionalesNegativos();
          }

          if (data[7].facturas != null) {
            if (data[7].facturas.length) {
              this.dataSourceFacturas.data = data[7].facturas;
            }
          }
          if (data[7].remitos != null) {
            if (data[7].remitos.length) {
              this.dataSourceRemitos.data = data[7].remitos;
            }
          }
          this.pepService.cPedidoEspecialPlantaRetenciones(cabecera.idPais, cabecera.idCompania, cabecera.idSalesOrg, cabecera.nroPedido)
            .subscribe((data: PedidoEspecialPlantaRetencion[]) => {
              this.retenciones = data;
            });

          if (cabecera.idEstado == 1) {
            //se guardo la cabecera pero no hay items
            this.clienteSeleccionado = new Cuenta();
            this.clienteSeleccionado.idPais = cabecera.idPais
            this.clienteSeleccionado.idSalesOrg = cabecera.idSalesOrg
            this.clienteSeleccionado.idCompania = cabecera.idCompania
            this.clienteSeleccionado.nroCliente = cabecera.nroCliente
            this.clienteSeleccionado.idCondicionPago = cabecera.idTerminoPago
            this.admService
              .cDataClienteSeleccionado(cabecera.idPais, cabecera.idCompania, cabecera.idSalesOrg, cabecera.idDivision, cabecera.nroCliente)
              .subscribe((datac: DataClientePedidos) => {

                if (datac != null) {
                  this.mensajeDeudaVencida = datac.mensajeDeudaVencida;
                  this.mensajeCreditoExcedido = datac.mensajeCreditoExcedido;
                  this.credito = datac.credito;
                  this.avisoCreditoVencido = datac.cuenta != null ? datac.cuenta.creditoVencido : false;
                  //this.avisoCreditoVencido = this.idTipo == 2 || this.idTipo == 3 ? false : this.avisoCreditoVencido;
                  this.regiones = datac.regiones != null ? datac.regiones : [];
                  this.dirEntregas = datac.direccionesEntregas != null ? datac.direccionesEntregas : []
                  this.gcs = datac.gruposCliente != null ? datac.gruposCliente : [];
                  if (this.gcs.length) {
                    if (cabecera.idGrupoCliente != null) {
                      this.pepaForm.controls['idGrupoCliente'].setValue(cabecera.idGrupoCliente);
                    }
                    else {
                      this.pepaForm.controls['idGrupoCliente'].setValue(datac.grupoCliente != null ? datac.grupoCliente.id : '');
                    }
                    this.seleccionarGC(this.pepaForm.controls['idGrupoCliente'].value)
                  }
                  this.cuentasDistribuidores = datac.cuentasDistribuidores != null ? datac.cuentasDistribuidores : [];
                  if (this.cuentasDistribuidores.length) {
                    if (cabecera.nroClienteDistribuidor != null) {
                      this.pepaForm.controls['nroClienteDistribuidor'].setValue(cabecera.nroClienteDistribuidor);
                    }
                    // else {
                    //   if (this.pepaForm.controls['idEstado'].value == 1) {
                    //     this.pepaForm.controls['nroClienteDistribuidor'].setValue(datac.cuentasDistribuidores[0].nroClienteDistribuidor);
                    //   }
                    // }
                    this.seleccionarCuentaDistribuidor(this.pepaForm.controls['nroClienteDistribuidor'].value);

                  }
                  else {
                    this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ClienteSinDisrtribuidores, 2, 2);
                  }
                  if (datac.direccionEntrega != null) {
                    this.seleccionarDirEntrega(datac.direccionEntrega);
                  }

                  if (cabecera.idRegion != null) {
                    this.pepaForm.controls['idRegion'].setValue(cabecera.idRegion);
                  }
                  else {
                    if (datac.zonaVendedor?.idRegion?.length) {
                      this.pepaForm.controls['idRegion'].setValue(datac.zonaVendedor.idRegion);
                    }
                    else {
                      this.pepaForm.controls['idRegion'].setValue(this.regiones != null && this.regiones.length ? this.regiones[0].id : '');
                    }
                  }
                  if (this.pepaForm.controls['idRegion'].valid) {
                    this.seleccionarRegion(this.pepaForm.controls['idRegion'].value);
                  }

                  this.zvSeleccionada = cabecera.zonaVendedor != null ? cabecera.zonaVendedor : (datac.zonaVendedor != null ? datac.zonaVendedor : null);

                  this.pepaForm.controls['idZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.id : '');
                  this.pepaForm.controls['usuarioRedZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.usuarioVendedor : '');
                  this.pepaForm.controls['nombreVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.descripcion : '');

                }

              })

            if (data[7].listaPreciosCabecera != null) {
              this.seleccionarLP(data[7].listaPreciosCabecera, data[7].idTerminoPago != null ? data[7].idTerminoPago : null)
            }

          } else {
            this.lpSeleccionada = new ListaPrecioCabecera()

            this.lpSeleccionada.id = this.pepaForm.controls['idTipoListaPrecios'].value;
            this.lpSeleccionada.descripcion = this.pepaForm.controls['tipoListaPrecios'].value
            this.lpSeleccionada.idMoneda = this.pepaForm.controls['idMonedaCD'].value


          }
        }
        let timer = setTimeout(() => {

          this.pepaForm.get('idDivision').valueChanges.subscribe(() => { this.limpiarCliente(true); })
          this.pepaForm.get('idGrupoCliente').valueChanges.subscribe(() => { this.limpiarLP(true); })
          this.pepaForm.get('idMoneda').valueChanges.subscribe(() => { this.limpiarItem(true); })
          this.pepaForm.get('idTerminoPago').valueChanges.subscribe(() => { this.limpiarItem(true); })

          loadData(this.pepaItemForm, this.pepaForm.value);
          this.pepaForm.controls['items'].reset();
          this.pepaForm.controls['itemsDescuento'].reset();
          this.pepaItemForm.controls['codigo'].reset();
          this.pepaItemForm.controls['codigo'].setValue(0);



        }, 2000);

      }

    });
    this.updateCantidadValidator();
  }
  updateCantidadValidator() {
    this.pepaItemForm.get('cantidad')?.setValidators([Validators.min(0.001), Validators.max(this.cuotaPlantaSeleccionada.cantidadDisponibleVenta)]);
    this.pepaItemForm.get('cantidad')?.updateValueAndValidity();
  }


  seleccionarMoneda(m: any) {

    this.monedaSeleccionada = null;
    if (m != null) {
      this.monedaSeleccionada = this.monedas.find(c => c.id == this.pepaForm.controls['idMoneda'].value);
      if (this.monedaSeleccionada != null) {
        this.pepaForm.controls['moneda'].setValue(this.monedaSeleccionada.descripcion);
      }
    }
    else {
      this.pepaForm.controls['moneda'].reset();
    }


  }
  seleccionarRegion(r: any) {

    this.regionSeleccionada = null;
    if (r != null) {
      this.regionSeleccionada = this.regiones.find(c => c.id == this.pepaForm.controls['idRegion'].value);
      if (this.regionSeleccionada != null) {
        this.pepaForm.controls['region'].setValue(this.regionSeleccionada.descripcion);
      }
    }
    else {
      this.pepaForm.controls['region'].reset();
    }

  }

  seleccionarCuentaDistribuidor(d: any) {

    this.ctaDistrubuidorSeleccionada = null;
    if (d != null) {
      this.ctaDistrubuidorSeleccionada = this.cuentasDistribuidores.length == 1 ? this.cuentasDistribuidores[0] : this.cuentasDistribuidores.find(c => c.nroClienteDistribuidor == d)
      if (this.ctaDistrubuidorSeleccionada != null) {

        this.pepaForm.controls['nombreDistribuidor'].setValue(this.ctaDistrubuidorSeleccionada.nombre);

      }

    }
    else {

      this.pepaForm.controls['nombreDistribuidor'].reset();
    }

  }
  seleccionarGC(g: any) {

    this.gcSeleccionado = null;
    if (g != null) {
      this.gcSeleccionado = this.gcs.find(c => c.id == this.pepaForm.controls['idGrupoCliente'].value);
      if (this.gcSeleccionado != null) {
        this.pepaForm.controls['grupoCliente'].setValue(this.gcSeleccionado.descripcion);
      }
    }
    else {
      this.pepaForm.controls['grupoCliente'].reset();
    }
  }

  seleccionarCliente(c: any, idGrupoCliente: string, nroClienteDistribuidor: string, idRegion: string, zonaVendedor: ZonaVendedor) {
    if (c != "-1") {

      this.clienteSeleccionado = c; //El autocomplete trae el objeto para asignar a la variable. El autocomplete NO esta enlazado con esta variable
      ;
      this.fcAutocompleteZv.reset();

      this.admService
        .cDataClienteSeleccionado(this.clienteSeleccionado.idPais, this.clienteSeleccionado.idCompania, this.clienteSeleccionado.idSalesOrg,
          this.pepaForm.controls['idDivision'].value, this.clienteSeleccionado.nroCliente)
        .subscribe((data: DataClientePedidos) => {
          this.pepaForm.controls['cuit'].setValue(this.clienteSeleccionado.cuit);
          this.pepaForm.controls['nroCliente'].setValue(this.clienteSeleccionado.nroCliente);
          this.pepaForm.controls['nombreCliente'].setValue(this.clienteSeleccionado.nombre);
          this.pepaForm.controls['idSalesOffice'].setValue(this.clienteSeleccionado.idSalesOffice)

          if (data != null) {

            this.mensajeDeudaVencida = data.mensajeDeudaVencida;
            this.mensajeCreditoExcedido = data.mensajeCreditoExcedido;
            this.credito = data.credito;
            this.avisoCreditoVencido = data.cuenta != null ? data.cuenta.creditoVencido : false;
            this.regiones = data.regiones != null ? data.regiones : [];
            this.dirEntregas = data.direccionesEntregas != null ? data.direccionesEntregas : []
            this.gcs = data.gruposCliente != null ? data.gruposCliente : [];
            if (this.gcs.length) {

              if (this.clienteSeleccionado.idTipoCliente != null) {
                this.pepaForm.controls['idGrupoCliente'].setValue(this.clienteSeleccionado.idTipoCliente);
              }
              else {
                this.pepaForm.controls['idGrupoCliente'].setValue(data.grupoCliente != null ? data.grupoCliente.id : '');
              }
              this.seleccionarGC(this.pepaForm.controls['idGrupoCliente'].value)
            }
            this.cuentasDistribuidores = data.cuentasDistribuidores != null ? data.cuentasDistribuidores : [];
            if (this.cuentasDistribuidores.length) {
              if (nroClienteDistribuidor != null) {
                this.pepaForm.controls['nroClienteDistribuidor'].setValue(nroClienteDistribuidor);
              }
              else {
                if (this.pepaForm.controls['idEstado'].value == 1) {
                  this.pepaForm.controls['nroClienteDistribuidor'].setValue(data.cuentasDistribuidores[0].nroClienteDistribuidor);
                }
              }
              this.seleccionarCuentaDistribuidor(this.pepaForm.controls['nroClienteDistribuidor'].value);

            }
            if (data.direccionEntrega != null) {
              this.seleccionarDirEntrega(data.direccionEntrega);
            }

            if (idRegion != null) {
              this.pepaForm.controls['idRegion'].setValue(idRegion);
            }
            else {
              if (data.zonaVendedor?.idRegion?.length) {
                this.pepaForm.controls['idRegion'].setValue(data.zonaVendedor.idRegion);
              }
              else {
                this.pepaForm.controls['idRegion'].setValue(this.regiones != null && this.regiones.length ? this.regiones[0].id : '');
              }
            }
            if (this.pepaForm.controls['idRegion'].valid) {
              this.seleccionarRegion(this.pepaForm.controls['idRegion'].value);
            }

            this.zvSeleccionada = zonaVendedor != null ? zonaVendedor : (data.zonaVendedor != null ? data.zonaVendedor : null);
            //this.pepaForm.controls['idRegion'].setValue(data.zonaVendedor?.idRegion?.length ? data.zonaVendedor.idRegion : this.regiones[0].id);
            this.pepaForm.controls['idZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.id : '');
            this.pepaForm.controls['usuarioRedZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.usuarioVendedor : '');
            this.pepaForm.controls['nombreVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.descripcion : '');
          }

        })

    } else {
      this.pepaForm.controls['idRegion'].reset();
      this.pepaForm.controls['idGrupoCliente'].reset();
      this.pepaForm.controls['cuit'].reset();
      this.pepaForm.controls['nroCliente'].reset();
      this.pepaForm.controls['nombreCliente'].reset();
      this.pepaForm.controls['idSalesOffice'].reset();
      this.clienteSeleccionado = null;
    }

  }


  getOptionTextCliente(option) {
    if (option != null) {
      return option.displayValue;
    }
  }


  handleEmptyInputCliente(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermCliente) {
      this.clientesEncontrados = [];
      this.clienteSeleccionado = null;

    }
  }


  limpiarCliente(resetFormControl: boolean) {
    this.mensajeCreditoExcedido = "";
    this.credito = null;
    this.mensajeDeudaVencida = "";
    this.clientesEncontrados = [];
    this.avisoCreditoVencido = false;
    this.limpiarVendedor(true);
    this.seleccionarDirEntrega(null);
    this.limpiarLP(true);
    this.seleccionarCuentaDistribuidor(null);
    this.seleccionarCliente("-1", null, null, null, null);
    this.cuentasDistribuidores = [];
    this.gcs = [];
    this.regiones = [];
    if (resetFormControl) {
      this.fcAutocompleteCliente.setValue('');

    };
    this.pepaForm.markAsUntouched();
    this.pepaForm.markAsPristine();

  }

  seleccionarVendedor(zv: any) {
    this.zvSeleccionada = zv;
    this.pepaForm.controls['idZonaVendedor'].setValue(this.zvSeleccionada.id);
    this.pepaForm.controls['usuarioRedZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.usuarioVendedor : '');
    this.pepaForm.controls['nombreVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.descripcion : '');
    if (this.regiones.length) {

      this.pepaForm.controls['idRegion'].setValue(this.zvSeleccionada.idRegion);
    }
  }

  handleEmptyInputVendedor(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermZV) {
      this.limpiarVendedor(false);
    }
  }
  limpiarVendedor(resetFormControl: boolean) {
    this.zvsEncontradas = [];
    this.zvSeleccionada = null;
    this.pepaForm.controls['idZonaVendedor'].reset();
    this.pepaForm.controls['idRegion'].reset();
    this.pepaForm.controls['usuarioRedZonaVendedor'].reset();
    this.pepaForm.controls['nombreVendedor'].reset();
    if (resetFormControl) {
      this.fcAutocompleteZv.setValue('');
    }

  }


  getOptionTextZV(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  seleccionarDirEntrega(de: any) {
    this.dirEntregaSeleccionada = null;
    if (de != null) {
      this.dirEntregaSeleccionada = this.dirEntregas.find(c => c.nroCliente == this.pepaForm.controls['nroClienteDireccionEntrega'].value);
      if (this.dirEntregaSeleccionada != null) {
        let nroClienteDirEntrega = this.pepaForm.controls['nroClienteDireccionEntrega'].value
        let estado = this.pepaForm.controls['idEstado'].value
        if (this.dirEntregaSeleccionada.nroCliente != nroClienteDirEntrega && estado == 3) {
          this.guardoDireccion = true
        }
        this.pepaForm.controls['nroClienteDireccionEntrega'].setValue(this.dirEntregaSeleccionada.nroCliente);
        this.pepaForm.controls['nombreClienteDireccionEntrega'].setValue(this.dirEntregaSeleccionada.nombre);
        this.pepaForm.controls['cpDireccionEntrega'].setValue(this.dirEntregaSeleccionada.codigoPostal);
        this.pepaForm.controls['ciudadDireccionEntrega'].setValue(this.dirEntregaSeleccionada.ciudad);
        this.pepaForm.controls['calleNroDireccionEntrega'].setValue(this.dirEntregaSeleccionada.calleNro);

        if (this.guardoDireccion) {
          this.guardar();
        }

      }
    }
    else {

      this.pepaForm.controls['nroClienteDireccionEntrega'].reset();
      this.pepaForm.controls['nombreClienteDireccionEntrega'].reset();
      this.pepaForm.controls['cpDireccionEntrega'].reset();
      this.pepaForm.controls['ciudadDireccionEntrega'].reset();
      this.pepaForm.controls['calleNroDireccionEntrega'].reset();
    }

  }

  seleccionarLP(lp: any, idTerminoPago: string) {
    this.limpiarItem(true);
    this.seleccionarTP(null);
    this.terminosPago = [];
    if (lp != "-1") {
      this.lpSeleccionada = lp;
      this.pepaForm.controls['idTipoListaPrecios'].setValue(this.lpSeleccionada.id);
      this.pepaForm.controls['tipoListaPrecios'].setValue(this.lpSeleccionada.descripcion);
      this.pepaForm.controls['idMonedaCD'].setValue(this.lpSeleccionada.idMoneda);
      this.pepaForm.controls['preciosFijos'].setValue(this.lpSeleccionada.precioFijo);
      this.pepService
        .cTerminosPagoTipoListaPrecios(this.lpSeleccionada.idPais, this.lpSeleccionada.idCompania, this.lpSeleccionada.idSalesOrg, this.lpSeleccionada.id)
        .subscribe((data: TerminoPago[]) => {

          if (data != null) {
            this.terminosPago = data;
            let tpAux: TerminoPago = null;
            if (idTerminoPago != null) {
              tpAux = this.terminosPago.find(c => c.id == idTerminoPago);
            }
            else {
              tpAux = this.terminosPago.find(c => c.id == this.clienteSeleccionado.idCondicionPago);
              if (!tpAux) this.pepaForm.controls['idTerminoPago'].setValue(null);

            }
            if (tpAux != null) {
              this.pepaForm.controls['idTerminoPago'].setValue(tpAux.id);
              this.seleccionarTP(this.pepaForm.controls['idTerminoPago'].value)

            }

          }

        })

    }
    else {
      this.pepaForm.controls['idTipoListaPrecios'].reset();
      this.pepaForm.controls['tipoListaPrecios'].reset();
      this.pepaForm.controls['idMonedaCD'].reset();
      this.lpSeleccionada = null;
    }
  }

  limpiarLP(resetFormControl: boolean) {
    this.lpsEncontradas = [];
    this.seleccionarLP("-1", null);
    if (resetFormControl) {
      this.fcAutocompleteLP.setValue('');
    }

  }


  getOptionTextLP(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  handleEmptyInputLP(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermLP) {
      this.lpsEncontradas = [];
      this.lpSeleccionada = null;

    }
  }

  seleccionarTP(tp: any) {

    this.tpSeleccionado = null;
    if (tp != null) {
      this.tpSeleccionado = this.terminosPago.find(c => c.id == tp);
      if (this.tpSeleccionado != null) {
        this.pepaForm.controls['terminoPago'].setValue(this.tpSeleccionado.descripcion);
      }
    }
    else {
      this.pepaForm.controls['terminoPago'].reset();
    }

  }

  seleccionarPlanta(p: any) {

    //this.seleccionarPlantaItem(null);
    // this.plantasItem = [];

    this.plantaSeleccionada = null;
    this.seleccionarPlantaItem(this.pepaForm.controls['idPlanta'].value);
    if (p != null) {
      this.plantaSeleccionada = this.plantas.find(c => c.idPlanta == p);
      if (this.plantaSeleccionada != null) {
        this.pepaForm.controls['planta'].setValue(this.plantaSeleccionada.descripcion);


        let pepai: PedidoEspecialPlantaItem = new PedidoEspecialPlantaItem(this.pepaForm.value);
        pepai.cantidad = 1;
        loadData(this.pepaItemForm, pepai);
        this.pepaForm.markAllAsTouched();
      }
    }
    else {
      this.pepaForm.controls['planta'].reset();

    }

  }
  seleccionarPlantaItem(pI: any) {

    this.storagesLocations = []
    this.plantaItemSeleccionada = null;
    this.limpiarItem(true);
    if (pI != null) {
      this.plantaItemSeleccionada = this.plantasItem.find(c => c.idPlanta == pI);
      if (this.plantaItemSeleccionada != null) {
        this.pepaItemForm.controls['planta'].setValue(this.plantaItemSeleccionada.descripcion);


        this.pepService
          .cStoragesLocationsPlanta(this.plantaItemSeleccionada.idPais, this.plantaItemSeleccionada.idCompania, this.plantaItemSeleccionada.idSalesOrg, this.plantaItemSeleccionada.idPlanta)
          .subscribe((data: UbicacionAlmacenamiento[]) => {

            if (data != null) {
              this.storagesLocations = data;

            }

          })
        this.pepaForm.markAllAsTouched();
      }
    }
    else {
      this.pepaItemForm.controls['planta'].reset();
      this.pepaItemForm.controls['idPlanta'].reset();

    }

  }

  seleccionarStorageLocation(sl: any) {
    this.limpiarItem(true);
    this.slSeleccionado = null;
    if (sl != null) {
      this.slSeleccionado = this.storagesLocations.find(c => c.id == this.pepaItemForm.controls['idUbicacionAlmacenamiento'].value);
    } else {
      this.pepaItemForm.controls['idUbicacionAlmacenamiento'].reset();
    }

  }

  seleccionarDivision(d: any) {

    this.divisionSeleccionada = null;
    if (d != null) {
      this.divisionSeleccionada = this.divisiones.find(c => c.id == this.pepaForm.controls['idDivision'].value);
      if (this.divisionSeleccionada != null) {
        this.pepaForm.controls['division'].setValue(this.divisionSeleccionada.descripcion);
      }
    }
    else {
      this.pepaForm.controls['division'].reset();
    }

  }
  seleccionarItem(i: any) {

    if (i != "-1") {
      this.itemSeleccionado = i;
      this.pepaItemForm.controls['idProducto'].setValue(this.itemSeleccionado.idProducto);
      this.pepaItemForm.controls['producto'].setValue(this.itemSeleccionado.producto);
      this.pepaItemForm.controls['precioUnitarioLista'].setValue(this.itemSeleccionado.tasa);
      if (this.itemSeleccionado != null) {
        this.pepService
          .cCuotasPlantas(this.itemSeleccionado.idPais, this.itemSeleccionado.idCompania, this.itemSeleccionado.idSalesOrg, this.pepaItemForm.controls['idPlanta'].value, this.pepaItemForm.controls['idUbicacionAlmacenamiento'].value, this.itemSeleccionado.idProducto)
          .subscribe((data: CuotaPlanta[]) => {

            if (data != null) {
              this.cuotasPlantas = data;

            }

          })
        this.pepaForm.markAllAsTouched();
      }

    }
    else {
      this.pepaItemForm.controls['idProducto'].reset();
      this.pepaItemForm.controls['producto'].reset();
      this.itemSeleccionado = null;
    }
  }

  seleccionarCuotaPlanta(cp: any) {

    this.cuotaPlantaSeleccionada = null;
    if (cp != null) {
      this.cuotaPlantaSeleccionada = this.cuotasPlantas.find(c => c.mesyAnio == cp);
      if (this.cuotaPlantaSeleccionada != null) {
        this.pepaItemForm.controls['cuotaPlantaMesyAnio'].setValue(this.cuotaPlantaSeleccionada.mesyAnio);

        this.pepaItemForm.controls['cantidad'].setValue(1);
        this.pepaItemForm.controls['cantidad'].clearValidators();
        this.pepaItemForm.controls['cantidad'].setValidators([Validators.min(0.001), Validators.max(this.cuotaPlantaSeleccionada.cantidadDisponibleVenta)]);
        this.pepaItemForm.controls['cantidad'].updateValueAndValidity();

      }
    }
    else {
      this.pepaItemForm.controls['cuotaPlantaMesyAnio'].reset();
    }


  }

  getOptionTextItem(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  handleEmptyInputItem(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermItem) {
      this.itemsEncontrados = [];
      this.itemSeleccionado = null;
    }
  }

  limpiarItem(resetFormControl: boolean) {
    this.itemsEncontrados = [];
    this.pepaItemForm.controls['cantidad'].setValue(1);
    this.cuotasPlantas = [];
    this.pepaItemForm.controls['cuotaPlantaMesyAnio'].setValue(-1);
    this.avisoUnidadesPallet = false
    this.seleccionarItem("-1");
    if (resetFormControl) {
      this.fcAutocompleteItem.setValue('');
    }
    this.pepaItemForm.markAsUntouched();
    this.pepaItemForm.markAsPristine();
    this.updateCantidadValidator();

  }

  compareCompanias(compLista: any, compPEPA: any): boolean {
    return compLista === compPEPA;
  }

  compareSalesOrgs(salesOrgLista: any, salesOrgPEPA: any): boolean {
    return salesOrgLista == salesOrgPEPA;
  }
  compareDivisiones(dLista: any, dPEPA: any): boolean {
    return dLista == dPEPA;
  }

  compareGC(gcLista: any, gcPEPA: any): boolean {
    return gcLista == gcPEPA;
  }

  compareRegiones(rLista: any, rPEPA: any): boolean {
    return rLista == rPEPA;
  }

  compareMonedas(mLista: any, mPEPA: any): boolean {
    return mLista == mPEPA;
  }
  compareCuentasDistribuidores(dLista: any, dPEPA: any): boolean {
    return dLista == dPEPA;
  }

  compareTerminosPago(tpLista: any, tpPEPA: any): boolean {
    return tpLista === tpPEPA;
  }
  comparePlantas(pLista: any, pPEPA: any): boolean {
    return pLista === pPEPA;
  }
  compareStoragesLocations(slLista: any, slPEPA: any): boolean {
    return slLista === slPEPA;
  }
  clasePorEstado(id: string) {
    let clase = ClasePorEstado("10", id);
    return clase;
  }
  compareCuotasPlantas(cLista: any, cPEPA: any): boolean {
    return cLista === cPEPA;
  }
  compareDireccionEntrega(deLista: any, de: any): boolean {
    return deLista === de;
  }
  scrollToInvalidFormControls(fg: FormGroup) {
    scrollToInvalidFromControls(this.pepa, fg);
  }


  dialogRetenciones() {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { cab: this.pepaForm.value }
    let dialogRef = this.dialog.open(PEPARetencionesDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: string) => {

    })
  }

  dialogLogAutorizaciones() {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { cab: this.pepaForm.value }
    let dialogRef = this.dialog.open(PEPALogsDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: string) => {

    })
  }
  dialogComentario(idTipo: number, required: boolean) {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { required: required }
    let dialogRef = this.dialog.open(ComentarioPedidoDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: string) => {
      if (data != null && typeof data != 'undefined') {
        this.pepaForm.controls['comentarioLogAutorizacion'].setValue(data);

        switch (idTipo) {
          case 1: //Aprobar 
            this.pepService.aprobarPedidoEspecialPlantaAnticipada(this.pepaForm.value).subscribe((data: PedidoEspecialPlantaCabecera) => {
              if (data != null) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AprobacionPedidoExitosa, 1, 2);
                this.regresarALaRutaAnterior();
              }

            })
            break;
          case 2: //Rechazar
            this.pepService.rechazarPedidoEspecialPlanta(this.pepaForm.value).subscribe((data: PedidoEspecialPlantaCabecera) => {
              if (data != null) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.RechazoPedidoExitoso, 1, 2);
                this.regresarALaRutaAnterior();
              }

            })
            break;
          case 3: //Rechazar cotización (Rechazar pedido por cliente)
            this.pepService.rechazarPedidoEspecialPlantaPorCliente(this.pepaForm.value).subscribe((data: PedidoEspecialPlantaCabecera) => {
              if (data != null) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.RechazoPedidoExitoso, 1, 2);
                this.regresarALaRutaAnterior();
              }

            })
            break;
        }

      }
    })
  }
  guardar() {

    if (this.pepaForm.valid) {

      this.pepaForm.controls['items'].setValue([]);
      this.pepaForm.controls['itemsDescuento'].setValue([])
      this.pepService
        .amPedidoEspecialPlanta(this.pepaForm.value)
        .subscribe((data: PedidoEspecialPlantaCabecera) => {
          if (data != null) {

            this.limpiarItem(true);
            if (this.codigoEdit == 0) {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 2);
            }
            else {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 2);
            }
            this.codigoEdit = data.codigo;
            this.pepaForm.controls['codigo'].setValue(this.codigoEdit);
            this.pepaForm.controls['nroPedido'].setValue(data.nroPedido);
            this.pepaItemForm.controls['nroPedido'].setValue(data.nroPedido);
            this.pepaForm.controls['aprobar'].setValue(data.aprobar);
            this.pepaForm.controls['aprobarReservado'].setValue(data.aprobarReservado);
            this.pepaForm.controls['reenviar'].setValue(data.reenviar);
            this.pepaForm.controls['borrador'].setValue(data.borrador);
            this.pepaForm.controls['aprobarParcial'].setValue(data.aprobarParcial);
            this.pepaForm.controls['rechazar'].setValue(data.rechazar);
            this.idTipo == 2
          }

        })
    }
    else {
      this.scrollToInvalidFormControls(this.pepaForm);
    }


  }

  nuevoItem() {
    if (this.itemSeleccionado.unidadesPallet == 0) {
      this.avisoUnidadesPallet = true
      this.mensajeUnidadesPallet = "No existen Kg/Litros para el producto"
    }
    else {

      const cantidadNum: number = this.pepaItemForm.controls['cantidad'].value;
      const unidadesPallet = this.itemSeleccionado.unidadesPallet
      var esMultiplo = Math.abs(cantidadNum / unidadesPallet - Math.round(cantidadNum / unidadesPallet)) < 1e-10;
      let valornum = cantidadNum / unidadesPallet

      if (!esMultiplo) {
        this.avisoUnidadesPallet = true;
        valornum = Math.floor(valornum) + 1
        this.mensajeUnidadesPallet = "La cantidad no corresponde a los Kg/Litros (" + unidadesPallet.toString() + "), cantidad sugerida: "
          + parseFloat((unidadesPallet * (valornum - 1)).toFixed(3)).toString() + " ó "
          + parseFloat((unidadesPallet * valornum).toFixed(3)).toString();
      } else {
        this.avisoUnidadesPallet = false;
      }
    }

    if (this.itemSeleccionado == null && this.pepaForm.valid) {
      this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, "Seleccioná un ítem.", 2, 2);
    }

    if (this.pepaForm.valid && this.pepaItemForm.valid && !this.avisoUnidadesPallet) {
      // this.pepaForm.controls['idCompania'].enable();
      // this.pepaForm.controls['idSalesOrg'].enable();
      this.pepaForm.controls['idCompania'].setValue(this.loggedService.logged.idCompania);
      this.pepaForm.controls['idSalesOrg'].setValue(this.loggedService.logged.idSalesOrg);
      let i: PedidoEspecialPlantaItem[] = []
      this.pepaItemForm.controls['idEstado'].setValue('');
      this.pepaItemForm.controls['estado'].setValue('');
      i.push(this.pepaItemForm.value);
      this.pepaForm.controls['items'].setValue(i);
      this.pepaItemForm.controls['autor'].setValue(this.loggedService.logged.userName);
      this.pepService
        .aPedidoEspecialPlantaItem(this.pepaForm.value)
        .subscribe((data: PedidoEspecialPlantaCabecera) => {
          if (data != null) {
            this.pepaForm.controls['aprobar'].setValue(data.aprobar);
            this.pepaForm.controls['aprobarReservado'].setValue(data.aprobarReservado);
            this.pepaForm.controls['reenviar'].setValue(data.reenviar);
            this.pepaForm.controls['borrador'].setValue(data.borrador);
            this.pepaForm.controls['aprobarParcial'].setValue(data.aprobarParcial);
            this.pepaForm.controls['rechazar'].setValue(data.rechazar);
            this.limpiarItem(true);
            if (this.codigoEdit == 0) {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 2);
            }
            else {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 2);
            }
            if (data.items != null) {
              if (data.items.length) {
                this.dataSourceItems.data = data.items;
                this.totalItems = this.dataSourceItems.data.map(a => a.total).reduce(function (a, b) {
                  return a + b;
                });
                this.cDescuentosDiscrecionalesNegativos();

              }
            }
            this.dataSourceItemsDescuentos.data = [];
            if (data.itemsDescuento != null) {
              if (data.itemsDescuento.length) {
                this.dataSourceItemsDescuentos.data = data.itemsDescuento;
              }
            }
            this.codigoEdit = data.codigo;
            this.pepaForm.controls['codigo'].setValue(this.codigoEdit);
            this.pepaForm.controls['items'].reset();

            this.idTipo == 2

          }

        })
    }
    else {
      if ((!this.pepaForm.valid && this.pepaItemForm.valid) || (!this.pepaForm.valid && !this.pepaItemForm.valid)) {
        this.scrollToInvalidFormControls(this.pepaForm);
      }
      else {
        this.scrollToInvalidFormControls(this.pepaItemForm);
      }
    }


  }

  cDescuentosDiscrecionalesNegativos() {
    this.descuentosDiscrecionalesNegativos = false;
    this.itemsConDescuentoDiscrecionalNegativo = [];
    if (this.pepaForm.controls['descuentoDiscrecional'].value < 0) {
      this.descuentosDiscrecionalesNegativos = true;
    }
    this.dataSourceItems.data.forEach(item => {
      if (item.descuentoDiscrecional < 0) {
        this.descuentosDiscrecionalesNegativos = true;
        this.itemsConDescuentoDiscrecionalNegativo.push(item);
      }
    });
  }

  eliminarItem(item: PedidoEspecialPlantaItem) {
    this.dialog
      .open(ConfirmacionDialogComponent, { panelClass: 'app-dialog', data: "¿Confirmas la eliminación del producto " + item.idProducto + " - " + item.producto + "?", width: 'auto', height: 'auto' })
      .afterClosed()
      .subscribe((Si: boolean) => {
        if (Si) {
          this.pepService.bPedidoEspecialPlantaItem(this.codigoEdit, item.codigo).subscribe((data: PedidoEspecialPlantaCabecera) => {

            if (data != null) {

              this.limpiarItem(true);

              this.dataSourceItems.data = [];
              this.totalItems = 0;
              if (data.items != null) {
                if (data.items.length) {
                  this.dataSourceItems.data = data.items;
                  this.totalItems = this.dataSourceItems.data.map(a => a.total).reduce(function (a, b) {
                    return a + b;
                  });
                  this.cDescuentosDiscrecionalesNegativos();
                }
              }
              this.dataSourceItemsDescuentos.data = [];
              if (data.itemsDescuento != null) {
                if (data.itemsDescuento.length) {
                  this.dataSourceItemsDescuentos.data = data.itemsDescuento;
                }
              }
              this.pepaForm.controls['descuentoDiscrecional'].setValue(data.descuentoDiscrecional);
              this.pepaForm.controls['descuentoCategoria'].setValue(data.descuentoCategoria);
              this.pepaForm.controls['recargo'].setValue(data.recargo);
              this.pepaForm.controls['recargoLocal'].setValue(data.recargoLocal);
              this.pepaForm.controls['preciosFijos'].setValue(data.preciosFijos);
              this.pepaForm.controls['aplicaDtoDiscrecionalxLP'].setValue(data.aplicaDtoDiscrecionalxLP);
              this.pepaForm.controls['aprobar'].setValue(data.aprobar);
              this.pepaForm.controls['aprobarParcial'].setValue(data.aprobarParcial);
              this.pepaForm.controls['aprobarReservado'].setValue(data.aprobarReservado);
              this.pepaForm.controls['aplicaDescDisc'].setValue(data.aplicaDescDisc);
              this.pepaForm.controls['aplicaPrecioFijoxLP'].setValue(data.aplicaPrecioFijoxLP);
              this.pepaForm.controls['rechazar'].setValue(data.rechazar);
              this.pepaForm.controls['reenviar'].setValue(data.reenviar);
              this.pepaForm.controls['borrador'].setValue(data.borrador);
              this.pepaForm.controls['items'].reset();
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 2);
            }
          })
        }
      })
  }
  dialogItem(item: PedidoEspecialPlantaItem) {

    if (this.lpSeleccionada != null) {

      this.productosService.cListaPrecioCabecera(this.pepaForm.controls['idPais'].value, this.pepaForm.controls['idCompania'].value, this.pepaForm.controls['idSalesOrg'].value, this.lpSeleccionada.id).subscribe((data: ListaPrecioCabecera) => {
        //Buscar la lp del pedido para ver si tiene precio fijo antes de editar el item
        if (data != null) {
          this.lpSeleccionada = data;
          this.pepaForm.controls['preciosFijos'].setValue(this.lpSeleccionada.precioFijo);

          this.pepaForm.controls['idCompania'].enable();
          this.pepaForm.controls['idSalesOrg'].enable();
          let config: MatDialogConfig = new MatDialogConfig();
          config.width = '100%';
          config.height = 'auto';
          let cab: PedidoEspecialPlantaCabecera = this.pepaForm.value;
          let pepai: PedidoEspecialPlantaItem = structuredClone(item);
          cab.items = [];
          cab.items.push(pepai);
          config.data = { cab: cab }
          let dialogRef = this.dialog.open(PEPAItemDialogComponent, config);
          let idCompania: string = this.pepaForm.controls['idCompania'].value;
          let idSalesOrg: string = this.pepaForm.controls['idSalesOrg'].value;
          this.pepaForm.controls['idCompania'].disable();
          this.pepaForm.controls['idSalesOrg'].disable();
          dialogRef.afterClosed().subscribe((data: number) => {
            if (data != 0) {
              this.pepService.cPedidoEspecialPlanta(this.loggedService.logged.idPais, idCompania, idSalesOrg, "10", this.codigoEdit).subscribe((data: PedidoEspecialPlantaCabecera) => {
                if (data != null) {

                  this.limpiarItem(true);
                  this.dataSourceItems.data = [];
                  this.totalItems = 0;
                  if (data.items != null) {
                    if (data.items.length) {
                      this.dataSourceItems.data = data.items;
                      this.totalItems = this.dataSourceItems.data.map(a => a.total).reduce(function (a, b) {
                        return a + b;
                      });
                      this.cDescuentosDiscrecionalesNegativos();
                    }
                  }
                  this.dataSourceItemsDescuentos.data = [];
                  if (data.itemsDescuento != null) {
                    if (data.itemsDescuento.length) {
                      this.dataSourceItemsDescuentos.data = data.itemsDescuento;
                    }
                  }
                  this.pepaForm.controls['descuentoDiscrecional'].setValue(data.descuentoDiscrecional);
                  this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 2);
                }

              })
            }
          })
        }

      })

    }

  }

  dialogAprobacionRetenido() {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { cab: this.pepaForm.value }
    let dialogRef = this.dialog.open(PEPAprobacionRetenidoDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: PedidoEspecialPlantaCabecera) => {
      if (data != null && typeof data != 'undefined') {
        if (typeof data != 'string') {

          //this.pepaForm.controls['comentarioLogAutorizacion'].setValue(data.comentarioLogAutorizacion);
          //this.pepaForm.controls['idMotivoRetencion'].setValue(data.idMotivoRetencion);
          this.pepaForm.controls['codigosRetencionesAprobadas'].setValue(data.codigosRetencionesAprobadas);

          this.pepService.aprobarPedidoEspecialPlantaRetenido(this.pepaForm.value).subscribe((data: PedidoEspecialPlantaCabecera) => {
            if (data != null) {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AprobacionPedidoExitosa, 1, 2);
              this.regresarALaRutaAnterior();
            }

          })
        }

      }
    })
  }
  cambioEstadoItem(codigoItem: number) {

    let codigo: number = this.pepaForm.controls['codigo'].value;

    this.pepService.aprobarRechazarPedidoItem(codigo, codigoItem).subscribe((data: PedidoEspecialPlantaCabecera) => {
      if (data != null) {
        this.dataSourceItems.data = [];
        this.dataSourceItems.data = data.items;
      }
    }
    )

  }

  volver() {
    this.router.navigateByUrl(this.configService.etiquetas.PedidosEspecialesPlantaAnticipada.Buscador.Path);
  }

  regresarALaRutaAnterior() {
    if (this.router.lastSuccessfulNavigation.extras.replaceUrl == undefined || this.router.lastSuccessfulNavigation.extras.replaceUrl) {
      var state = this.router.lastSuccessfulNavigation.extras.state;
      if (state) {
        this.router.navigateByUrl(state.rutaAnterior || '/');
      }
      else {
        this.volver();
      }
    }
    else {
      this.volver();
    }
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

  checkCantidad(formControl: any) { //Para evitar que un formcontrol quede en blanco o null

    if (!this.pepaItemForm.get(formControl).value) {
      this.pepaItemForm.get(formControl).setValue(0, { onlySelf: true, emitEvent: false }); // Esto es para poner su valor en 0 si se queda en blanco, sin disparar valueChanges
    }
  }

  download(nombrepdf: string) {
    this.admService.downloadPdf(nombrepdf).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = nombrepdf;
      anchor.click();
      window.URL.revokeObjectURL(url);
    }, error => {
      console.error('Error downloading file:', error);
    });
  }
} 
